import { atom, useAtom } from "jotai";
import { debounce } from "lodash";
import { useCallback, useEffect, useMemo, useRef } from "react";

const searchAtom = atom<string>("");
const inputValueAtom = atom<string>("");

export const useOrderSearch = () => {
  const searchRef = useRef<HTMLInputElement>(null);
  const [search, setSearch] = useAtom(searchAtom);
  const [inputValue, setInputValue] = useAtom(inputValueAtom);

  // Debounce Search
  const debouncedSearch = useMemo(
    () =>
      debounce(
        (newVal: string) => {
          setSearch(newVal);
        },
        800,
        { trailing: true }
      ),
    [setSearch]
  );

  const handleInputChange = useCallback(
    (value: string) => {
      setInputValue(value);
      debouncedSearch(value);
    },
    [debouncedSearch, setInputValue]
  );

  const clearSearch = useCallback(() => {
    setInputValue("");
    debouncedSearch("");
  }, [debouncedSearch, setInputValue]);

  // Reset search state when component unmounts
  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
      setSearch("");
      setInputValue("");
    };
  }, [debouncedSearch, setSearch, setInputValue]);

  return {
    searchRef,
    search,
    inputValue,
    handleInputChange,
    clearSearch,
  };
};
